import router from '@/router'
import store from '../store'
export default {
  //当不传path参数时，path为当前路由值
  //是否有读权限
  canRead(path = null) {
    return this.can("读", path);
  },
  //是否有写权限
  canWrite(path = null) {
    return this.can("写", path);
  },
  //是否有导入权限
  canImport(path = null) {
    return this.can("导入", path);
  },
  //是否有导出权限
  canExport(path = null) {
    return this.can("导出", path);
  },
  //是否有审核权限
  canReview(path = null) {
    return this.can("审核", path);
  },
  can(action, path = null) {
    if (!path) {
      path = router.history.current.fullPath;
    }
    // 
    // 
    return store.state.sys.permissionMenus.some(item => {
      if (item.FullPath == path || item.PermissionPath == path) {
        return item.FuncNames.indexOf(action) != -1 || false;
      }
    })
  },
  //是否有某个菜单
  hasMenu(path) {
    return store.state.sys.permissionMenus.some(item => item.fullPath == path || item.permissionPath == path);
  }
}